export default __webpack_public_path__ + "static/media/logo-black.f318b563.svg";